import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { getAssetUrl } from 'src/app/shared/asset';
import { TitleService } from 'src/app/shared/title.service';
import { Theme, defaultTheme } from 'src/app/theme/theme';
import { UserInfo } from 'src/app/user-info';
import { UserService } from '../user.service';

interface SectionMenu {
  label: string;
  param: string;
}

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss'],
  standalone: false
})
export class UserComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private userService = inject(UserService);
  private titleService = inject(TitleService);

  userInfo: UserInfo;
  profileRoutes = ['Gifts', 'Topics'];
  menus: SectionMenu[] = [
    {
      label: 'Gifts',
      param: 'gifts'
    },
    {
      label: 'Topics',
      param: 'topics'
    }
  ];
  section = this.menus[0].param;

  ngOnInit() {
    this.titleService.setTitle('Profile');
    window.scrollTo(0, 0);
    this.route.queryParams.subscribe((queryParams) => {
      this.section = queryParams['section'];
    });
    this.route.data.subscribe((data) => {
      this.userInfo = data['userInfo'];
      if (!this.userInfo) {
        this.router.navigate(['404'], { skipLocationChange: true });
      }
    });
  }

  get theme(): Theme {
    return this.userInfo.character?.theme ?? defaultTheme;
  }

  get currentSectionMenu(): SectionMenu {
    const menu = this.menus.find((menu) => menu.param === this.section);
    return menu ?? this.menus[0];
  }

  get menuLabels(): string[] {
    return this.menus.map((menu) => menu.label);
  }

  get selectedMenuIndex(): number {
    const menuIndex = this.menus.findIndex((menu) => menu.param === this.section);
    return menuIndex >= 0 ? menuIndex : 0;
  }

  onClickMenu(index: number) {
    this.router.navigate([], {
      queryParams: { section: this.menus[index].param }
    });
  }

  get avatarImageUrl(): string {
    return getAssetUrl(this.userInfo.avatarImage?.path);
  }

  get owner(): boolean {
    return this.userInfo?.username === this.userService.userInfo?.username;
  }

  get isTribeSelected(): boolean {
    if (!this.userInfo.character || !this.userInfo.character.tribe) {
      return false;
    }
    return true;
  }
}
